import React from 'react';
import * as styles from './index.module.scss';
import { GatsbyImage, getImage } from "gatsby-plugin-image";

export const Partnerships = ({ data }) => {
  return (
    <section className={styles.partners}>
      <p className={styles.title}>Partnerships</p>

      <div className={styles.logos}>
        {data && data.map((item, index) => {
          const image = item?.image;

          if (!image) {
            return null;
          }

          const logo = image?.gatsbyImageData !== null ? (
            <GatsbyImage
              alt={image?.title}
              className={styles.image}
              image={getImage(image)}
            />
          ) : (
            <img
              alt={image?.title}
              className={styles.image}
              height="70"
              src={image?.url}
              width="70"
            />
          );

          return (
            <div className={styles.logoItem} key={`partner-logo-wrapper-${index}`}>
              {item?.url ? (
                <a href={item.url} className={styles.logoLink} target="_blank" rel="noopener noreferrer">
                  {logo}
                </a>
              ) : (
                logo
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};
